import {useEffect, useState} from "react";
import {convertBooleanToMainOutputControl, convertMainOutputControlToBoolean} from "../IndicatorHelper";
import {validation} from "../../../../../helpers/ValidationHelper";

const defaultSettings = {
    mainOutputControl: false,
    currentSetPoint: 0,
    voltageSetPoint: 0
};

function validateCurrentSetPoint(value) {
    return value >= 0;
}

function validateVoltageSetPoint(value) {
    return value >= 0;
}

export default function UseSorensenXgControl({pipe, onChanged, onApply}) {
    const [settings, setSettings] = useState(defaultSettings);
    const [applying, setApplying] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});

    const hasErrors = !!Object.keys(validationErrors).length;

    useEffect(() => {
        setSettings(pipe.settings ? {
            mainOutputControl: convertMainOutputControlToBoolean(pipe.settings["main_output_control"]),
            currentSetPoint: pipe.settings["current_set_point"] || defaultSettings.currentSetPoint,
            voltageSetPoint: pipe.settings["voltage_set_point"] || defaultSettings.voltageSetPoint
        } : defaultSettings);
    }, [pipe.id, pipe.settings]);

    function handleMainOutputControlChanged(value) {
        setSettings(Object.assign({}, settings, {mainOutputControl: value}));
    }

    function handleCurrentSetPointChanged(value) {
        setValidationErrors(validation(
            value,
            "current_set_point",
            validationErrors,
            validateCurrentSetPoint
        ));

        const newSetting = Object.assign(settings);

        newSetting.currentSetPoint = value;

        setSettings(newSetting);
    }

    function handleVoltageSetPointChanged(value) {
        setValidationErrors(validation(
            value,
            "voltage_set_point",
            validationErrors,
            validateVoltageSetPoint
        ));

        const newSetting = Object.assign(settings);

        newSetting.voltageSetPoint = value;

        setSettings(newSetting);
    }

    function handleApplyClick() {
        if (hasErrors) return;

        setApplying(true);

        onChanged(pipe.id, {
            "main_output_control": convertBooleanToMainOutputControl(settings.mainOutputControl),
            "current_set_point": settings.currentSetPoint,
            "voltage_set_point": settings.voltageSetPoint
        });

        onApply(pipe.id).finally(() => setApplying(false));
    }

    return {
        settings,
        applying,
        hasErrors,
        validationErrors,
        handleMainOutputControlChanged,
        handleCurrentSetPointChanged,
        handleVoltageSetPointChanged,
        handleApplyClick
    }
}